import React, { useState, useContext } from 'react';
import {
  Accordion,
  AccordionItem,
  SearchBar,
  Loading,
} from '@ktag/styleguide/dist/react';
import { useTranslation } from 'react-i18next';
import uniqid from 'uniqid';
import { useQuery } from '@tanstack/react-query';
import AppContext from 'AppContext';
import { Newsletter } from 'types/api.types';
import Actions from '../actions/Actions';

const List = () => {
  const { t } = useTranslation('newsletter');
  const [search, setSearch] = useState('');
  const { newsletterApi } = useContext(AppContext);

  const { data, isLoading } = useQuery<Newsletter[]>(['newsletters'], () =>
    newsletterApi.getNewsletters(),
  );

  const sortNewsletters = (a: Newsletter, b: Newsletter) => {
    const aName = a?.name?.replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue');
    const bName = b?.name?.replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue');
    return aName?.localeCompare(bName);
  };

  const filteredNewsletters = data
    ?.filter((newsletter) => newsletter.name.toLowerCase().includes(search.toLowerCase()))
    .sort(sortNewsletters);

  if (isLoading) {
    return <Loading size="medium" />;
  }

  return (
    <div className="list">
      <h2 className="list__header">{t('list_title', { value: data?.length })}</h2>
      <SearchBar
        search={search}
        setSearch={setSearch}
        placeholder={t('list_search_newsletters')}
      />
      <Accordion multiselectable unmountOnClose>
        {filteredNewsletters?.map((item) => {
          return (
            <AccordionItem title={item.name} key={uniqid()} noUrlRewrite>
              <p>{item.description}</p>
              <Actions
                id={item.id}
                showSubscribe
                showAdditionalInformation
                showUnsubscribe
                urlAdditionalInformation={item.link}
              />
            </AccordionItem>
          );
        })}
      </Accordion>
    </div>
  );
};

export default List;
